import { render, staticRenderFns } from "./AvisoLimiteAssinaturaExpirado.vue?vue&type=template&id=3718142e"
import script from "./AvisoLimiteAssinaturaExpirado.vue?vue&type=script&lang=js"
export * from "./AvisoLimiteAssinaturaExpirado.vue?vue&type=script&lang=js"
import style0 from "./AvisoLimiteAssinaturaExpirado.vue?vue&type=style&index=0&id=3718142e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports